import { render, staticRenderFns } from "./TopicComponent.vue?vue&type=template&id=9f6c39f8&scoped=true&"
import script from "./TopicComponent.vue?vue&type=script&lang=ts&"
export * from "./TopicComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TopicComponent.vue?vue&type=style&index=0&id=9f6c39f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6c39f8",
  null
  
)

component.options.__file = "TopicComponent.vue"
export default component.exports